// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible/flexible.js'
import VueI18n from 'vue-i18n'
import Common from '@/common/common'

Vue.use(VueI18n)
Vue.config.productionTip = false
Vue.prototype.Common = Common;

const i18n = new VueI18n({
    locale: Common.locale,
    messages: {
      'zh': require('./i18n/zh.js'), 
      'en': require('./i18n/en.js'),
      'tw': require('./i18n/tw.js')
    }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js